import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Card, List, Typography, Space, Tag, Spin, Alert, Empty } from "antd";

import AppHeader from "../../components/Header";
import AppFooter from "../../components/Footer";
import "./index.css";

const { Content } = Layout;
const { Title, Text } = Typography;

function groupByYear(posts = []) {
  const map = new Map();
  posts.forEach((p) => {
    const year = (p.date || "").slice(0, 4) || "未知";
    if (!map.has(year)) map.set(year, []);
    map.get(year).push(p);
  });
  return Array.from(map.entries()).sort((a, b) => String(b[0]).localeCompare(String(a[0])));
}

export default function Archive({ posts, loading, error, loggedInUser, onLogout }) {
  const nav = useNavigate();
  const grouped = useMemo(() => groupByYear(posts || []), [posts]);

  return (
    <Layout className="dmc dmc-layout page-shell archive-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />

      <Content className="page-content archive-content">
        <div className="archive-container">
          <Title level={3} style={{ marginBottom: 8 }}>文章归档</Title>
          <Text type="secondary">按年份查看文章</Text>

          {loading ? (
            <div className="state-block"><Spin /></div>
          ) : error ? (
            <div className="state-block">
              <Alert type="error" showIcon message="加载失败" description={String(error)} />
            </div>
          ) : grouped.length === 0 ? (
            <div className="state-block"><Empty description="暂无文章" /></div>
          ) : (
            <div style={{ marginTop: 16 }}>
              {grouped.map(([year, list]) => (
                <Card key={year} className="year-card" title={<Space><Text strong>{year}</Text><Text type="secondary">({list.length} 篇)</Text></Space>}>
                  <List
                    dataSource={list}
                    renderItem={(post) => (
                      <List.Item className="archive-item" onClick={() => nav(`/post/${post.id}`)}>
                        <div className="archive-row">
                          <div className="archive-left">
                            <Text type="secondary" className="archive-date">{post.date}</Text>
                            <Text className="archive-title">{post.title}</Text>
                          </div>
                          <Space size={6} wrap>
                            {(post.tags || []).slice(0, 4).map((t) => <Tag key={t}>#{t}</Tag>)}
                          </Space>
                        </div>
                      </List.Item>
                    )}
                  />
                </Card>
              ))}
            </div>
          )}
        </div>
      </Content>

      <AppFooter />
    </Layout>
  );
}
